import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { setAnalyticsChoice, type AnalyticsChoice } from '../analytics'

export function CookieBanner() {
  const [visible, setVisible] = useState(true)
  const [preferences, setPreferences] = useState(false)
  const [analytics, setAnalytics] = useState(false)
  const [measurement, setMeasurement] = useState(false)
  useEffect(() => {
    try { setVisible(localStorage.getItem('pc_cookie_choice') === null) } catch { /* Keep the choice available if storage is blocked. */ }
  }, [])
  if (!visible) return null
  const choose = (value: AnalyticsChoice) => {
    setAnalyticsChoice(value)
    setVisible(false)
  }
  return (
    <aside className="cookie-banner" aria-label="Cookie choices">
      <div className="cookie-heading">
        <strong>Cookies at China Care</strong>
        <button className="cookie-decline" onClick={() => choose('essential')}>Continue without consent <X size={14} aria-hidden="true" /></button>
      </div>
      <p>With your permission, we use cookies to understand website use and measure advertising results. No personalised ads. Your medical answers, contact details and attachments stay out of analytics. <Link to="/privacy">Privacy policy</Link></p>
      {preferences && <fieldset className="cookie-preferences" id="cookie-preferences">
        <legend>Cookie preferences</legend>
        <div className="cookie-required"><span>Necessary cookies</span><span>Always on</span></div>
        <label><input type="checkbox" checked={analytics} onChange={event => { setAnalytics(event.target.checked); if (!event.target.checked) setMeasurement(false) }} /><span><b>Analytics</b><small>Help us understand how visitors use the website.</small></span></label>
        <label><input type="checkbox" checked={measurement} disabled={!analytics} onChange={event => setMeasurement(event.target.checked)} /><span><b>Ad measurement</b><small>Connect Google ad clicks with successful enquiries. Requires analytics. Optional cookies last up to 90 days.</small></span></label>
      </fieldset>}
      <div className="cookie-actions">
        <button className="button button-quiet" aria-expanded={preferences} aria-controls="cookie-preferences" onClick={() => setPreferences(value => !value)}>{preferences ? 'Back' : 'Cookie preferences'}</button>
        <button className="button" onClick={() => choose(preferences ? measurement ? 'measurement' : analytics ? 'analytics' : 'essential' : 'measurement')}>{preferences ? 'Save my choices' : 'Accept all cookies'}</button>
      </div>
    </aside>
  )
}
